import { DebugService } from './debug.service.js';
import { stratum } from '../../../constants/stratum.js';

class _ExperimentService {
  constructor() {
    this.debug = new DebugService('ExperimentService');
    this._experiments = [];
    this.abTest = null;
    this._abTests = {
      name: 'offers-ab-tests',
      variationIds: [],
      testGroup: '',
      testWeight: 1,
    };
  }

  get experiments() {
    return this._experiments;
  }

  set experiments(experiments) {
    this._experiments = experiments;
  }

  updateExperiments(newExperiments, removeExperiments = [], removeExperimentType = null) {
    stratum.endAbTest(this.abTest);
    const newlyAddedExperiments = newExperiments.map(experiment => experiment.toLowerCase());
    let updatedExperimentsNoSpecificType = this._experiments;
    if (removeExperimentType) {
      updatedExperimentsNoSpecificType = this._experiments.filter(experiment => !experiment.toLowerCase().includes(removeExperimentType.toLowerCase()));
    }
    const updatedExperiments = updatedExperimentsNoSpecificType.filter(experiment => !removeExperiments.includes(experiment));
    this._experiments = Array.from(new Set(updatedExperiments.concat(newlyAddedExperiments)));
    this._abTests.variationIds = this._experiments;
    this.abTest = stratum.startAbTest(this._abTests);
  }

  updateStratumExperiments(arrayOfFeatureObjects) {
    const newlyAddedFeatures = [];
    const removedFeatures = [];
    arrayOfFeatureObjects.forEach(featureObj => {
      newlyAddedFeatures.push(featureObj.featureKey + (featureObj.isEnabled ? '-test' : '-bau'));
      removedFeatures.push(featureObj.featureKey + (featureObj.isEnabled ? '-bau' : '-test'));
    });
    this.updateExperiments(newlyAddedFeatures, removedFeatures);
  }
}
export const ExperimentService = new _ExperimentService();
